/* global mapboxgl, MapboxGeocoder */

Apt.fn.make('showrooms', {
	/**
	 * Initialize module
	 */
	init: function() {
		var priv = this.$private;

		$.assets.load({
			js: 'https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js',
			success: function() {
				$.assets.load({
					root: 'https://api.mapbox.com/mapbox-gl-js',
					css: '/v1.5.0/mapbox-gl.css',
					js: [
						'/v1.5.0/mapbox-gl.js',
						'/plugins/mapbox-gl-geocoder/v4.7.3/mapbox-gl-geocoder.min.js',
						'/plugins/mapbox-gl-supported/v1.4.1/mapbox-gl-supported.js'
					],
					success: function() {
						if (! mapboxgl.supported()) {
							return;
						}

						priv.setup();
					}
				});
			}
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('showrooms');

		if ($.app.locations) {
			$.app.locations.$destroy();
		}
	}
}, {
	/**
	 * Create a locations list and map
	 */
	setup: function() {
		var scope = this,
			$geocoder = $$('geocoder'),
			$map = $$('map'),
			segment = $.routes.segments(1),
			country = 'US',
			placeholder = 'Enter your City and ';

		if (segment === 'canada') {
			country = 'CA';
			placeholder += 'Province, or Postal Code';
		} else if (segment === 'mexico') {
			country = 'MX';
			placeholder += 'State, or Postal Code';
		} else {
			placeholder += 'State, or ZIP Code';
		}

		$.app.make('locations', {
			target: 'ref:locations',
			view: 'showrooms.locations'
		});

		mapboxgl.accessToken = $map.data('token');

		scope.map = new mapboxgl.Map({
			container: $map[0],
			center: [-118.03698, 33.741624],
			style: $map.data('style'),
			zoom: 1
		});

		scope.geocoder = new MapboxGeocoder({
			accessToken: mapboxgl.accessToken,
			countries: country,
			flyTo: false,
			limit: 4,
			marker: false,
			placeholder: placeholder,
			types: 'locality,place,postcode,region'
		});

		scope.geocoder.on('result', function(e) {
			if ($.equals(scope.center, e.result.center)) {
				return;
			}

			scope.center = e.result.center;
			scope.search();

			scope.geocode = e.result;
		});

		$geocoder.append(scope.geocoder.onAdd(scope.map));

		$('input', $geocoder).on('click', function() {
			this.value = '';
		}, {
			namespace: 'showrooms'
		});
	},

	/**
	 * Fetch sorted locations
	 *
	 * @param {String} url
	 */
	search: function(url) {
		var scope = this,
			segment = $.routes.segments(1),
			country = 'US';

		if (segment === 'canada') {
			country = 'CA';
		} else if (segment === 'mexico') {
			country = 'MX';
		}

		$.fetch.request({
			url: url || '/showrooms/locations',
			json: true,
			data: {
				lat: scope.center[1],
				lng: scope.center[0],
				country: country
			},
			success: function(data) {
				scope.render('locations', data);
			}
		});
	},

	/**
	 * Render the location list and map
	 *
	 * @param {Object} app
	 * @param {Object} data
	 */
	render: function(app, data) {
		var scope = this,
			bounds = new mapboxgl.LngLatBounds(),
			$showrooms = $$('showrooms');

		scope.locations = $.map(data.features, function(feature) {
			return feature.properties;
		});

		scope.paginate = data.paginate;

		$.app[app].$set('locations', scope.locations);
		$.app[app].$set('paginate', scope.paginate);

		if (scope.markers) {
			scope.markers.forEach(function(marker) {
				marker.remove();
			});
		}

		scope.markers = [];

		data.features.forEach(function(marker, index) {
			var $marker = $('<div class="showrooms__marker">' + marker.properties.count + '</div>');

			scope.markers[index] = new mapboxgl.Marker({
				element: $marker[0],
				anchor: 'bottom'
			})
				.setLngLat(marker.geometry.coordinates)
				.addTo(scope.map);

			$marker.on({
				mouseenter: function() {
					$.app[app].$set('locations.' + index + '.active', true);
				},
				mouseleave: function() {
					$.app[app].$set('locations.' + index + '.active', false);
				}
			});

			bounds.extend(marker.geometry.coordinates);
		});

		$$('location').on({
			mouseenter: function(e, el) {
				$(scope.markers[$(el).data('index')].getElement()).addClass('-is-active');
			},
			mouseleave: function(e, el) {
				$(scope.markers[$(el).data('index')].getElement()).removeClass('-is-active');
			}
		});

		$$('paginate').on('click', function(e, el) {
			scope.search($(el).data('href'));

			if ($.screen.size() < 4) {
				$.animate.tween($._body, {
					scrollTop: $$('locations').offset().top
				});
			}
		});

		$showrooms.show();

		if ($.screen.size() > 3) {
			$.animate.tween($._body, {
				scrollTop: $$('form').offset().top + 50
			});
		}

		scope.map.resize()
			.fitBounds(bounds, {
				duration: 200,
				maxZoom: 12,
				padding: 120
			});
	}
});
